module.exports = __webpack_public_path__ + "static/media/future-in-it.39aa8e6b.png";